// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__QP2Yj","signatureBlock":"Footer_signatureBlock__2mype","signature":"Footer_signature__3cSIm"};